/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Typography2 } from '@coursera/cds-core';
import { StarFilledIcon } from '@coursera/cds-icons';

import { MIN_RATING_COUNT } from 'bundles/product-card/constants';

type Props = { avgProductRating?: number; numProductRatings?: number };

const styles = {
  ratingContainer: css`
    display: flex;
    align-items: center;
    gap: calc(var(--cds-spacing-50) / 2);
  `,
  ratingText: css`
    display: inline-block;
    line-height: 1;
  `,
};

const ProductCardReviews = ({ avgProductRating, numProductRatings }: Props) => {
  if (!avgProductRating || !numProductRatings || numProductRatings <= MIN_RATING_COUNT) {
    return null;
  }

  const rating = Math.round(avgProductRating * 10) / 10;

  return (
    <div aria-label={`${rating} out of 5 stars`} css={styles.ratingContainer}>
      <StarFilledIcon color="default" size="small" />
      <Typography2 variant="bodyTertiary" component="span" color="supportText" css={styles.ratingText}>
        {rating}
      </Typography2>
    </div>
  );
};

export default ProductCardReviews;
